import { createRoot } from "react-dom/client";
import "./colors.css";
import App from "./components/App";
import "./global.css";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
